// shipping swiper slider

document.addEventListener('DOMContentLoaded', function () {
    let shippingswipers = [];

    function initShippingSwiper(swiperContainer) {
        var desktop = swiperContainer.data("desktop");
        var large_tablet = swiperContainer.data("large-tablet");
        var tablet = swiperContainer.data("tablet");
        var mobile = swiperContainer.data("mobile");
        var autoplay = swiperContainer.data("autoplay");

        var shippingSwiper = new Swiper(swiperContainer, {
            slidesPerView: desktop,
            spaceBetween: 30,
            autoplay: autoplay,
            grabCursor: true,
            freeMode: false,
            mousewheel: false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: ".shipping-swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                0: {
                    slidesPerView: mobile,
                    spaceBetween: 15
                },
                576: {
                    slidesPerView: tablet,
                    spaceBetween: 15
                },
                768: {
                    slidesPerView: large_tablet,
                    spaceBetween: 15
                },
                992: {
                    slidesPerView: desktop
                }
            },
        });

        shippingswipers.push(shippingSwiper);
    }

    // Initialize shipping swiper on page load
    $('.Shipping-inner-row').each(function () {
        initShippingSwiper($(this));
    });

    document.addEventListener('shopify:section:select', function () {
        // Reinitialize shipping swiper on section select
        shippingswipers.forEach(function (swiper) {
            swiper.destroy();
        });
        shippingswipers = [];
        $('.Shipping-inner-row').each(function () {
            initShippingSwiper($(this));
        });
    });

    document.addEventListener('shopify:section:load', function () {
        // Reinitialize shipping swiper on section load
        shippingswipers.forEach(function (swiper) {
            swiper.destroy();
        });
        shippingswipers = [];
        $('.Shipping-inner-row').each(function () {
            initShippingSwiper($(this));
        });
    });

    document.addEventListener('shopify:section:deselect', function () {
        // Cleanup shipping swiper on section deselect if necessary
        shippingswipers.forEach(function (swiper) {
            swiper.destroy();
        });
        shippingswipers = [];
    });
});

// featured-collection swiper slider

document.addEventListener('DOMContentLoaded', function() {
  var featuredCollectionSwipers = [];

  function initFeaturedCollectionSwiper(swiperContainer) {
    var enable = swiperContainer.data("enable-slider"); 
    var desktop = swiperContainer.data("desktop");
    var large_tablet = swiperContainer.data("large-tablet");
    var tablet = swiperContainer.data("tablet");
    var mobile = swiperContainer.data("mobile");
    var autoplay = swiperContainer.data("autoplay");
    var loop = swiperContainer.data("loop");
    var speed = swiperContainer.data("speed");
      
    if (enable) {
      var featuredCollectionSwiper = new Swiper(swiperContainer, {
        slidesPerView: desktop,
        spaceBetween: 30,
        loop: true,
        autoplay: autoplay,
        loop: loop,
        speed: speed,
        dots: true,
        navigation: {
          nextEl: swiperContainer.find('.swiper-button-next'),
          prevEl: swiperContainer.find('.swiper-button-prev'),
        },
        pagination: {
          el: swiperContainer.find('.featured-swiper-pagination'),
          clickable: true,
        },
        breakpoints: {
          320: {
            slidesPerView: mobile,
            spaceBetween: 15
          },
          576: {
            slidesPerView: tablet,
            spaceBetween: 15
          },
          641: {
            slidesPerView: tablet,
            spaceBetween: 15
          },
          768: {
            slidesPerView: large_tablet,
            spaceBetween: 15
          },
          991: {
            slidesPerView: large_tablet,
            spaceBetween: 15
          },
          1099: {
            slidesPerView: desktop
          },
        },
      });

      featuredCollectionSwipers.push(featuredCollectionSwiper);
    }
  }

  // Initialize Featured Collection Swiper on page load
  $('.swiper-container.demo').each(function() {
    initFeaturedCollectionSwiper($(this));
  });

  document.addEventListener('shopify:section:select', function() {
    // Reinitialize Featured Collection Swiper on section select
    featuredCollectionSwipers.forEach(function(swiper) {
      swiper.destroy();
    });
    featuredCollectionSwipers = [];
    $('.swiper-container.demo').each(function() {
      initFeaturedCollectionSwiper($(this));
    });
  });

  document.addEventListener('shopify:section:load', function() {
    // Reinitialize Featured Collection Swiper on section load
    featuredCollectionSwipers.forEach(function(swiper) {
      swiper.destroy();
    });
    featuredCollectionSwipers = [];
    $('.swiper-container.demo').each(function() {
      initFeaturedCollectionSwiper($(this));
    });
  });

  document.addEventListener('shopify:section:deselect', function() {
    // Cleanup Featured Collection Swiper on section deselect if necessary
    featuredCollectionSwipers.forEach(function(swiper) {
      swiper.destroy();
    });
    featuredCollectionSwipers = [];
  });
});

// testimonial swiper slider

document.addEventListener('DOMContentLoaded', function() {
  let testimonialSwipers = [];

  function initTestimonialSwiper(swiperContainer) {
    var desktop = swiperContainer.data("desktop");
    var tablet = swiperContainer.data("tablet");
    var mobile = swiperContainer.data("mobile");
    var autoplay = swiperContainer.data("autoplay");
    var loop = swiperContainer.data("loop");
    var speed = swiperContainer.data("speed");
    var freemode = swiperContainer.data("freemode");
    var mousewheel = swiperContainer.data("mousewheel");

    var testimonial = new Swiper(swiperContainer, {
      spaceBetween: 30,
      freeMode: freemode,
      loop: loop,
      speed: speed,
      autoplay: autoplay,
      mousewheel: mousewheel,
      navigation: {
        nextEl: swiperContainer.find(".testi-swiper-button-next"),
        prevEl: swiperContainer.find(".testi-swiper-button-prev"),
      },
      pagination: {
        el: swiperContainer.find('.testimonial-swiper-pagination'),
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {
        320: {
          slidesPerView: mobile,
          spaceBetween: 15
        },
        480: {
          slidesPerView: mobile,
          spaceBetween: 15
        },
        576: {
          slidesPerView: mobile,
          spaceBetween: 15
        },
        768: {
          slidesPerView: tablet,
          spaceBetween: 15
        },
        992: {
          slidesPerView: desktop
        },
      },
    });

    testimonialSwipers.push(testimonial);
  }

  // Initialize testimonial swiper on page load
  $('.testimonial-wrap').each(function() {
    initTestimonialSwiper($(this));
  });

  document.addEventListener('shopify:section:select', function() {
    // Reinitialize testimonial swiper on section select
    testimonialSwipers.forEach(function(swiper) {
      swiper.destroy();
    });
    testimonialSwipers = [];
    $('.testimonial-wrap').each(function() {
      initTestimonialSwiper($(this));
    });
  });

  document.addEventListener('shopify:section:load', function() {
    // Reinitialize testimonial swiper on section load
    testimonialSwipers.forEach(function(swiper) {
      swiper.destroy();
    });
    testimonialSwipers = [];
    $('.testimonial-wrap').each(function() {
      initTestimonialSwiper($(this));
    });
  });

  document.addEventListener('shopify:section:deselect', function() {
    // Cleanup testimonial swiper on section deselect if necessary
    testimonialSwipers.forEach(function(swiper) {
      swiper.destroy();
    });
    testimonialSwipers = [];
  });
});

// gallery swiper slider
document.addEventListener('DOMContentLoaded', function() {
  let gallerySwipers = [];

  function initGallerySwiper(swiperContainer) {
    var autoplay = swiperContainer.data("autoplay");
    var loop = swiperContainer.data("loop");
    
    var gallerySwiper = new Swiper(swiperContainer, {
      slidesPerView: "auto",
      centeredSlides: false,
      spaceBetween: 30,
      autoplay: autoplay,
      loop: loop,
      navigation: {
        nextEl: swiperContainer.find('.swiper-button-next'),
        prevEl: swiperContainer.find('.swiper-button-prev'),
      },
      pagination: {
        el: swiperContainer.find('.gallery-swiper-pagination'),
        clickable: true,
      },
    });

    gallerySwipers.push(gallerySwiper);
  }

  // Initialize Gallery swiper on page load
  $('.gallery-swiper').each(function() {
    initGallerySwiper($(this));
  });

  document.addEventListener('shopify:section:select', function() {
    // Reinitialize Gallery swiper on section select
    gallerySwipers.forEach(function (swiper) {
      swiper.destroy();
    });
    gallerySwipers = [];
    $('.gallery-swiper').each(function () {
      initGallerySwiper($(this));
    });
  });

  document.addEventListener('shopify:section:load', function() {
    // Reinitialize Gallery swiper on section load
    gallerySwipers.forEach(function (swiper) {
      swiper.destroy();
    });
    gallerySwipers = [];
    $('.gallery-swiper').each(function () {
      initGallerySwiper($(this));
    });
  });

  document.addEventListener('shopify:section:deselect', function() {
    // Cleanup Gallery swiper on section deselect if necessary
    gallerySwipers.forEach(function (swiper) {
      swiper.destroy();
    });
    gallerySwipers = [];
  });
});

// tab-product swiper slider
document.addEventListener('DOMContentLoaded', function() {
  let tabSwipers = [];

  function initTabSwiper(swiperContainer) {
    var enable = swiperContainer.data("enable-slider");
    var desktop = swiperContainer.data("desktop");
    var largeTablet = swiperContainer.data("large-tablet");
    var tablet = swiperContainer.data("tablet");
    var mobile = swiperContainer.data("mobile");
    var autoplay = swiperContainer.data("autoplay");
    var loop = swiperContainer.data("loop");
    var speed = swiperContainer.data("speed");

    if (enable) {
      var tabswiper = new Swiper(swiperContainer, {
        slidesPerView: 1,
        spaceBetween: 30,
        observer: true,
        observeParents: true,
        dots: true,
        loop: loop,
        speed: speed,
        autoplay: autoplay,
        pagination: {
          el: swiperContainer.find(".tab-swiper-pagination"),
          clickable: true,
        },
        navigation: {
          nextEl: swiperContainer.find(".swiper-button-next"),
          prevEl: swiperContainer.find(".swiper-button-prev"),
        },
        breakpoints: {
          320: {
            slidesPerView: mobile,
            spaceBetween: 15,
          },
          576: {
            slidesPerView: tablet,
            spaceBetween: 15,
          },
          641: {
            slidesPerView: largeTablet,
            spaceBetween: 15,
          },
          990: {
            slidesPerView: desktop,
          },
        },
      });

      tabSwipers.push(tabswiper);
    }
  }

  // Initialize Tab Swiper on page load
  $('.swiper-container#lg-product-tab-slider').each(function () {
    initTabSwiper($(this));
  });

  document.addEventListener('shopify:section:select', function () {
    // Reinitialize Tab Swiper on section select
    tabSwipers.forEach(function (swiper) {
      swiper.destroy();
    });
    tabSwipers = [];
    $('.swiper-container#lg-product-tab-slider').each(function () {
      initTabSwiper($(this));
    });
  });

  document.addEventListener('shopify:section:load', function () {
    // Reinitialize Tab Swiper on section load
    tabSwipers.forEach(function (swiper) {
      swiper.destroy();
    });
    tabSwipers = [];
    $('.swiper-container#lg-product-tab-slider').each(function () {
      initTabSwiper($(this));
    });
  });

  document.addEventListener('shopify:section:deselect', function () {
    // Cleanup Tab Swiper on section deselect if necessary
    tabSwipers.forEach(function (swiper) {
      swiper.destroy();
    });
    tabSwipers = [];
  });
});

// blog swiper slider

document.addEventListener('DOMContentLoaded', function() {
  let blogSwipers = [];

  function initBlogSwiper(swiperContainer) {
    const config = {
      slidesPerView: 1,
      grabCursor: true,
      freeMode: swiperContainer.data("freemode"),
      autoplay: swiperContainer.data("autoplay"),
      spaceBetween: 30,
      loop: swiperContainer.data("loop"),
      speed: swiperContainer.data("speed"),
      mousewheel: swiperContainer.data("mousewheel"),
      keyboard: {
        enabled: true
      },
      pagination: {
        el: swiperContainer.find(".blog-swiper-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: swiperContainer.find(".swiper-button-next"),
        prevEl: swiperContainer.find(".swiper-button-prev")
      },
      breakpoints: {
        320: {
          slidesPerView: swiperContainer.data("mobile"),
          spaceBetween: 15
        },
        480: {
          slidesPerView: swiperContainer.data("mobile"),
          spaceBetween: 15
        },
        576: {
          slidesPerView: swiperContainer.data("tablet"),
          spaceBetween: 15
        },
        840: {
          slidesPerView: swiperContainer.data("tablet"),
          spaceBetween: 15
        },
        992: {
          slidesPerView: swiperContainer.data("desktop")
        },
      }
    };

    const blog = new Swiper(swiperContainer, config);
    blogSwipers.push(blog);
  }

  function cleanupBlogSwipers() {
    blogSwipers.forEach(function(swiper) {
      swiper.destroy();
    });
    blogSwipers = [];
  }

  // Initialize blog swiper on page load
  $('.swiper-slider-blog').each(function() {
    initBlogSwiper($(this));
  });

  document.addEventListener('shopify:section:select', function() {
    // Reinitialize blog swiper on section select
    cleanupBlogSwipers();
    $('.swiper-slider-blog').each(function() {
      initBlogSwiper($(this));
    });
  });

  document.addEventListener('shopify:section:deselect', function() {
    // Cleanup blog swiper on section deselect if necessary
    cleanupBlogSwipers();
  });
});

// instagram swiper slider
document.addEventListener('DOMContentLoaded', function() {
    let instagramSwipers = [];

    function initInstagramSwiper(swiperContainer) {
        var desktop = swiperContainer.data("desktop");
        var largeTablet = swiperContainer.data("large-tablet");
        var tablet = swiperContainer.data("tablet");
        var mobile = swiperContainer.data("mobile");
        var autoplay = swiperContainer.data("autoplay");
        var loop = swiperContainer.data("loop");
        var speed = swiperContainer.data("speed");

        var instagram = new Swiper(swiperContainer, {
            slidesPerView: 1,
            spaceBetween: 30,
            autoplay: autoplay,
            grabCursor: true,
            freeMode: false,
            loop: loop,
            speed: speed,
            mousewheel: false,
            navigation: {
                nextEl: swiperContainer.find(".swiper-button-next"),
                prevEl: swiperContainer.find(".swiper-button-prev")
            },
            pagination: {
                el: swiperContainer.find(".instagram-swiper-pagination"),
                clickable: true
            },
            breakpoints: {
                320: {
                    slidesPerView: mobile,
                    spaceBetween: 15
                },
                480: {
                    slidesPerView: tablet,
                    spaceBetween: 15
                },
                641: {
                    slidesPerView: largeTablet,
                    spaceBetween: 15
                },
                768: {
                    slidesPerView: largeTablet,
                    spaceBetween: 15
                },
                992: {
                    slidesPerView: desktop
                }
            }
        });

        instagramSwipers.push(instagram);
    }

    // Initialize Instagram swiper on page load
    $('.main-instagram-post-section-wrapper').each(function () {
        initInstagramSwiper($(this));
    });

    document.addEventListener('shopify:section:select', function () {
        // Reinitialize Instagram swiper on section select
        instagramSwipers.forEach(function (swiper) {
            swiper.destroy();
        });
        instagramSwipers = [];
        $('.main-instagram-post-section-wrapper').each(function () {
            initInstagramSwiper($(this));
        });
    });

    document.addEventListener('shopify:section:deselect', function () {
        // Cleanup Instagram swiper on section deselect if necessary
        instagramSwipers.forEach(function (swiper) {
            swiper.destroy();
        });
        instagramSwipers = [];
    });
});

// brand swiper slider

document.addEventListener('DOMContentLoaded', function() {
    let brandSwipers = [];

    function initBrandSwiper(swiperContainer) {
        var desktop = swiperContainer.data("desktop");
        var largeTablet = swiperContainer.data("large-tablet");
        var tablet = swiperContainer.data("tablet");
        var mobile = swiperContainer.data("mobile");
        var autoplay = swiperContainer.data("autoplay");
        var loop = swiperContainer.data("loop");
        var speed = swiperContainer.data("speed");

        var brand = new Swiper(swiperContainer, {
            slidesPerView: 1,
            spaceBetween: 120,
            autoplay: autoplay,
            grabCursor: true,
            freeMode: false,
            loop: loop,
            speed: speed,
            mousewheel: false,
            navigation: {
                nextEl: swiperContainer.find(".swiper-button-next"),
                prevEl: swiperContainer.find(".swiper-button-prev")
            },
            pagination: {
                el: swiperContainer.find(".brand-swiper-pagination"),
                clickable: true
            },
            breakpoints: {
                320: {
                    slidesPerView: mobile,
                    spaceBetween: 30
                },
                480: {
                    slidesPerView: tablet,
                    spaceBetween: 60
                },
                767: {
                    slidesPerView: tablet,
                    spaceBetween: 80
                },
                990: {
                    slidesPerView: largeTablet,
                    spaceBetween: 100
                },
                1199: {
                    slidesPerView: largeTablet,
                    spaceBetween: 120
                },
                1429: {
                    slidesPerView: desktop
                }
            }
        });

        brandSwipers.push(brand);
    }

    // Initialize brand swiper on page load
    $('.brand-slider-section-wrapper').each(function () {
        initBrandSwiper($(this));
    });

    document.addEventListener('shopify:section:select', function () {
        // Reinitialize brand swiper on section select
        brandSwipers.forEach(function (swiper) {
            swiper.destroy();
        });
        brandSwipers = [];
        $('.brand-slider-section-wrapper').each(function () {
            initBrandSwiper($(this));
        });
    });

    document.addEventListener('shopify:section:load', function () {
        // Reinitialize brand swiper on section load
        initBrandSwiper();
    });

    document.addEventListener('shopify:section:deselect', function () {
        // Cleanup brand swiper on section deselect if necessary
        brandSwipers.forEach(function (swiper) {
            swiper.destroy();
        });
        brandSwipers = [];
    });
});

// category collection swiper slider

document.addEventListener('DOMContentLoaded', function() {
    let categorySwipers = [];

    function initCategorySwiper(swiperContainer) {
        var enable = swiperContainer.data("enable");
        var desktop = swiperContainer.data("desktop");
        var largeTablet = swiperContainer.data("large-tablet");
        var tablet = swiperContainer.data("tablet");
        var mobile = swiperContainer.data("mobile");
        var autoplay = swiperContainer.data("autoplay");
        var loop = swiperContainer.data("loop");
        var speed = swiperContainer.data("speed");

        var categorySwiper = new Swiper(swiperContainer, {
            slidesPerView: 1,
            spaceBetween: 60,
            autoplay: autoplay,
            grabCursor: true,
            freeMode: false,
            speed: speed,
            loop: loop,
            mousewheel: false,
            navigation: {
                nextEl: swiperContainer.find(".swiper-button-next"),
                prevEl: swiperContainer.find(".swiper-button-prev")
            },
            pagination: {
                el: swiperContainer.find(".category-swiper-pagination"),
                clickable: true
            },
            breakpoints: {
                320: {
                    slidesPerView: mobile,
                    spaceBetween: 15
                },
                480: {
                    slidesPerView: tablet,
                    spaceBetween: 15
                },
                576: {
                    slidesPerView: tablet,
                    spaceBetween: 15
                },
                640: {
                    slidesPerView: tablet,
                    spaceBetween: 15
                },
                768: {
                    slidesPerView: largeTablet,
                    spaceBetween: 15
                },
                992: {
                    slidesPerView: largeTablet,
                    spaceBetween: 30
                },
                1199: {
                    slidesPerView: desktop
                }
            }
        });

        categorySwipers.push(categorySwiper);
    }

    // Initialize category swiper on page load
    $('.main-collection-list-wrapper').each(function () {
        initCategorySwiper($(this));
    });

    document.addEventListener('shopify:section:select', function () {
        // Reinitialize category swiper on section select
        categorySwipers.forEach(function (swiper) {
            swiper.destroy();
        });
        categorySwipers = [];
        $('.main-collection-list-wrapper').each(function () {
            initCategorySwiper($(this));
        });
    });

    document.addEventListener('shopify:section:load', function () {
        // Reinitialize category swiper on section load
        initCategorySwiper();
    });

    document.addEventListener('shopify:section:deselect', function () {
        // Cleanup category swiper on section deselect if necessary
        categorySwipers.forEach(function (swiper) {
            swiper.destroy();
        });
        categorySwipers = [];
    });
});